import { useQuery } from "@tanstack/react-query";
import { getMyFeedback } from "@/lib/api";
import { useScopedKey } from "@/lib/queryClient";
import type { FeedbackBundle } from "@/lib/types";

/**
 * The `/api/my-feedback` bundle hook (M7) — one round-trip feeding
 * every `/feedback` list tab.
 *
 * Scope-keyed: the backend resolves the viewer's team from the request
 * scope (`apiFetch` auto-injects `team_id` from the scope store), so
 * multi-team viewers must not reuse another active team's cached bundle.
 * Include both active team and season in the query key so scope changes
 * remount the feedback bundle in a pending state instead of showing stale
 * notes/reviews from the previous team while the refetch is in flight.
 *
 * The shell can disable the query after `/api/me` proves the signed-in
 * role should not use the player/guardian feedback surface.
 */
export function useMyFeedback(enabled = true) {
  const queryKey = useScopedKey("my-feedback");
  return useQuery<FeedbackBundle>({
    queryKey,
    queryFn: getMyFeedback,
    enabled,
  });
}
